import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-2048">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2049">
        <div className="flex justify-between items-center py-4" data-id="element-2050">
          <div className="flex items-center" data-id="element-2051">
            <div className="text-2xl font-bold text-indigo-600" data-id="element-2052">
              Screen IQ
            </div>
          </div>
          <nav className="hidden md:flex space-x-8" data-id="element-2053">
            <NavItem label="Features" hasDropdown data-id="element-2054">
              <DropdownMenu data-id="element-2055">
                <DropdownItem data-id="element-2056">AI Conversation Engine</DropdownItem>
                <DropdownItem data-id="element-2057">Candidate Intelligence</DropdownItem>
                <DropdownItem data-id="element-2058">Bot Detection</DropdownItem>
                <DropdownItem data-id="element-2059">Smart Ranking</DropdownItem>
              </DropdownMenu>
            </NavItem>
            <NavItem label="Solutions" hasDropdown data-id="element-2060">
              <DropdownMenu data-id="element-2061">
                <DropdownItem data-id="element-2062">Enterprise</DropdownItem>
                <DropdownItem data-id="element-2063">Mid-Market</DropdownItem>
                <DropdownItem data-id="element-2064">Staffing Agencies</DropdownItem>
              </DropdownMenu>
            </NavItem>
            <NavItem label="Pricing" data-id="element-2065" />
            <NavItem label="Resources" hasDropdown data-id="element-2066">
              <DropdownMenu data-id="element-2067">
                <DropdownItem data-id="element-2068">Blog</DropdownItem>
                <DropdownItem data-id="element-2069">Case Studies</DropdownItem>
                <DropdownItem data-id="element-2070">Documentation</DropdownItem>
              </DropdownMenu>
            </NavItem>
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-2071">
            <button className="text-gray-600 hover:text-gray-900" data-id="element-2072">
              Log In
            </button>
            <button className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors" data-id="element-2073">
              Get Started
            </button>
          </div>
          <div className="md:hidden" data-id="element-2074">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-2075">
              {isMenuOpen ? <X size={24} data-id="element-2076" /> : <Menu size={24} data-id="element-2077" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white px-4 pt-2 pb-4 border-b border-gray-200" data-id="element-2078">
          <div className="flex flex-col space-y-3" data-id="element-2079">
            <MobileNavItem label="Features" data-id="element-2080" />
            <MobileNavItem label="Solutions" data-id="element-2081" />
            <MobileNavItem label="Pricing" data-id="element-2082" />
            <MobileNavItem label="Resources" data-id="element-2083" />
            <div className="pt-4 flex flex-col space-y-3" data-id="element-2084">
              <button className="text-gray-600 py-2" data-id="element-2085">Log In</button>
              <button className="bg-indigo-600 text-white px-4 py-2 rounded-md" data-id="element-2086">
                Get Started
              </button>
            </div>
          </div>
        </div>}
    </header>;
};
const NavItem = ({
  label,
  hasDropdown = false,
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="relative" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)} data-id="element-2087">
      <button className="flex items-center text-gray-600 hover:text-gray-900 focus:outline-none" data-id="element-2088">
        {label}
        {hasDropdown && <ChevronDown size={16} className="ml-1" data-id="element-2089" />}
      </button>
      {hasDropdown && isOpen && children}
    </div>;
};
const DropdownMenu = ({
  children
}) => {
  return <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10" data-id="element-2090">
      {children}
    </div>;
};
const DropdownItem = ({
  children
}) => {
  return <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" data-id="element-2091">
      {children}
    </a>;
};
const MobileNavItem = ({
  label
}) => {
  return <button className="flex justify-between items-center w-full py-2 text-gray-600" data-id="element-2092">
      <span data-id="element-2093">{label}</span>
      {label !== 'Pricing' && <ChevronDown size={16} data-id="element-2094" />}
    </button>;
};